import { gsap } from "gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";

var $ = jQuery;
$(document).ready(function ($) {
    gsap.registerPlugin(ScrollTrigger);

    gsap.utils.toArray('.sublist-item').forEach(item => {
      gsap.from(item, {
        opacity: 0,
        y: 50,
        duration: 0.8,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: item,
          start: 'top 80%', // when item top hits 80% of viewport height
          toggleActions: 'play none none reverse', // animate on scroll down, reset on scroll up
        }
      });
    });
})

